import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

const style = makeStyles(theme => ({
  linkText: {
    marginBottom: `1em !important`,
    color: `#FFF`,
    textDecoration: `underline`,
    fontSize: 12,
  },
}))

export default function Link({ label, target, value, ...rest }) {
  const classes = style()

  return (
    <>
      <a className={classes.linkText} href={value} target={target} rel="noopener noreferrer">
        {label}
      </a>
    </>
  )
}
